import { observer } from "mobx-react-lite";

const SingleRow = ({ values }) => {
    // values = { title: "1-5", list: [2019, 1029, 2930, 1200, ...] }

    return (
        <tr>
            <td>{values.title}</td>
            {values && values.list.length > 0 && values.list.map((col, index) => 
                <td key={col+index}><div className={"yellowBg"}>{col}</div></td>
            )}
        </tr>
    );
}

export default observer(SingleRow);
